// mapping from image filename to emoij syntax
export default {
  sweat: 'vsweat',
  go: 'vgo',
  lmao: 'vlmao',
  after_boom: 'vaboom',
  adore: 'vadore',
  ah: 'vah',
  angry: 'vangry',
  bad_smelly: 'vbad_smelly',
  baffle: 'vbaffle',
  beat_plaster: 'vbeat_plaster',
  beauty: 'vbeauty',
  boss: 'vboss',
  beat_brick: 'vbrick',
  byebye: 'vbyebye',
  canny: 'vcanny',
  nosebleed: 'vchaymau',
  choler: 'vcholer',
  confident: 'vconfident',
  confuse: 'vconfuse',
  cry: 'vcry',
  doubt: 'vdoubt',
  embarrassed: 'vembarrassed',
  brick: 'vgach',
  hell_boy: 'vhell_boy',
  hungry: 'vhungry',
  look_down: 'vlook_down',
  matrix: 'vmatrix',
  misdoubt: 'vmisdoubt',
  oh: 'voh',
  ops: 'vops',
  pudency: 'vpudency',
  rap: 'vrap',
  sad: 'vsad',
  sexy_girl: 'vsexy',
  shame: 'vshame',
  beat_shot: 'vshot',
  smile: 'vsmile',
  feel_good: 'vsogood',
  burn_joss_stick: 'vstick',
  still_dreaming: 'vstill_dreaming',
  sure: 'vsure',
  surrender: 'vsurrender',
  tire: 'vtire',
  what: 'vwhat',
};
